import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const opsgenieScheduleRedirectRoute: InvariantJiraRoute = {
	name: 'opsgenie-schedule-redirect',
	path: '/projects/:projectKey',
	query: ['selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'],
};
